<template>
    <div>
        Partner Uploaded Documents (Restricted)
        <v-btn
            icon
            x-small
            class="ml-3 mt-n1 primary--text d-inline"
            :style="refresh_docs ? 'border:none' : 'border:1px solid #0096A6'"
            :loading="refresh_docs"
            @click="refreshDocs()">
            <v-icon v-if="!refresh_docs"
                small
                class="primary--text">
                mdi-autorenew
            </v-icon>
        </v-btn>
        <div class="d-inline ml-3">{{ (projectDetails.partner_docs.length) }} file{{ (projectDetails.partner_docs.length) == 1 ? '':'s' }}</div>

        <v-data-table
            v-if="projectDetails.partner_docs.length"
            :headers="doc_headers"
            :items="projectDetails.partner_docs"
            :loading="refresh_docs"
            disable-pagination
            hide-default-footer>
            
            <template v-slot:header="{ headers }">
                <thead>
                    <tr>
                        <td v-for="column in headers" :key="column.value">
                            {{column.text}}
                        </td>
                    </tr>
                </thead>
            </template>

            <template v-slot:body="{ items }">
                <tbody name="list" is="transition-group">
                    <tr v-for="item in items" :key="item.key" class="item-row avenir_book">
                        <td class="text-start"><a :href="item.url" class="clean_link" target="_blank">{{ item.file_name }}</a></td>
                        <td class="text-start text-capitalize" width="22%">Partner Information</td>
                        <td class="text-start text-capitalize" width="20%">{{ item.question }}</td>
                        <td class="text-start" width="14%">{{ formatDate(item.file_upload_date, 'mmm. d, yyyy') }}</td>
                    </tr>
                </tbody>
            </template>
        </v-data-table>
    </div>
</template>


<script>  
    import dateFormat, { masks } from "dateformat";

    export default {
        name: 'ProjectPartnerDocs',

        props: {
            projectDetails: {},
            refresh_docs: Boolean,
            pullProjectDocs: Function,
        },

        data () {
            return {
                doc_headers: [
                    {   text: 'File Name',     
                        value: 'file_name',    
                        align: 'start',  
                        sortable: true 
                    },
                    {   text: 'Section',     
                        value: 'section',
                        align: 'left',    
                        sortable: true 
                    },
                    {   text: 'Question',     
                        value: 'question',
                        align: 'left',    
                        sortable: true 
                    },
                    {   text: 'Uploaded',     
                        value: 'file_upload_date',
                        align: 'left',    
                        sortable: true 
                    },
                ],
                rev_headers: [
                    {   text: 'File Name',     
                        value: 'file_name',    
                        align: 'start',  
                        sortable: true,
                        class: "xtralight_primary"
                    },
                    {   text: '',     
                        value: '',
                        align: 'left',    
                        sortable: false,
                        class: "xtralight_primary"
                    },
                    {   text: 'Revisions',     
                        value: '',
                        align: 'left',    
                        sortable: false,
                        class: "xtralight_primary"
                    },
                    {   text: 'Uploaded',     
                        value: 'file_upload_date',
                        align: 'left',    
                        sortable: true,
                        class: "xtralight_primary"
                    },
                ],
            }
        },

        watch: {
            refresh_docs (val) {
                this.refresh_docs = val;
            },

        },
        
        methods: {
            refreshDocs: function () {
                this.$emit('pullProjectDocs', this.projectDetails );
            },

            formatDate: function ( date, mask ) {
                return dateFormat(date, mask)
            },
        },

        mounted () {
            // console.log(this.projectDetails)
        }
}
</script>

<style scoped>
    .clean_link {
        text-decoration: none;
    }
</style>


// WEBPACK FOOTER //
// src/components/ProjectPartnerDocs.vue